module.exports = __webpack_public_path__ + "img/mostly-cloudy-rain.653975d.svg";